import React from "react";
import Card from "@amzn/meridian/card";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import ThemedTag from "./inspectionReview/ThemedTag";

interface CheckpointCardProps {
  number: string;
  text: string;
  mode: string;
}

const CheckpointCard: React.FC<CheckpointCardProps> = ({ number, text, mode }) => {
  return (
    <Card spacingInset="400">
      <Column spacing="200">
        <Row alignmentHorizontal="justify" alignmentVertical="top">
          <Text type="h100">{number}</Text>
          <ThemedTag
            type="neutral"
            text={mode === "ai" || mode === "image" ? "AI" : "Manual"}
          />
        </Row>
        <Text type="b200">{text}</Text>
      </Column>
    </Card>
  );
};

export default CheckpointCard;
